<template>
  <b-container fluid>
    <b-overlay :show="isLoading" rounded="sm">
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-brand href="#" class="text-dark">
          <strong>My Onboarding</strong>
        </b-navbar-brand>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button variant="outline-info" size="sm" class="mr-2" @click="reloadTable">
                <font-awesome-icon icon="sync" />
              </b-button>
              <b-form-group>
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <b-table
        class="mx-1"
        striped
        sticky-header="calc(100vh - 200px)"
        ref="table"
        bordered
        id="users-data-table"
        :busy.sync="isLoading"
        :fields="staticFields"
        :items="getOnboardingTableData"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
      >
        <template v-slot:cell(created_at)="data">
          <p>{{ createdAtDate(data.item.created_at) }}</p>
        </template>
        <template
          v-slot:cell(type)="data"
        >{{data.item.type.charAt(0).toUpperCase() + data.item.type.slice(1)}}</template>
        <template
          v-slot:cell(created_by)="data"
        >{{data.item.created_by_contact_first_name+' '+data.item.created_by_contact_last_name}}</template>
        <template v-slot:cell(employee_name)="data">{{data.item.first_name+' '+data.item.last_name}}</template>
        <template v-slot:cell(progress)="data">
          <p>{{data.item.complated_onboarding_tasks_count}}/{{data.item.onboarding_tasks.length}}</p>
          <b-progress
            :value="data.item.complated_onboarding_tasks_count"
            :max="data.item.onboarding_tasks.length"
            variant="success"
          ></b-progress>
        </template>
        <template v-slot:cell(status)="data">
          <b-badge v-if="data.item.status == '0'" variant="info">Pending</b-badge>
          <b-badge v-if="data.item.status == '1'" variant="warning">In Progress</b-badge>
          <b-badge v-if="data.item.status == '2'" variant="danger">On hold</b-badge>
          <b-badge v-if="data.item.status == '4'" variant="success">Complete</b-badge>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button size="sm" variant="outline-primary" @click="data.toggleDetails">
            <font-awesome-icon icon="plus" title="View Onboarding Tasks"></font-awesome-icon>
          </b-button>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-table
              fixed
              :fields="taskTableFields"
              :items="row.item.onboarding_tasks"
              small
              head-variant="dark"
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(task_status)="data">
                <b-badge v-if="data.item.task_status == '0'" variant="info">Pending</b-badge>
                <b-badge v-if="data.item.task_status == '1'" variant="warning">In Progress</b-badge>
                <b-badge v-if="data.item.task_status == '2'" variant="danger">On hold</b-badge>
                <b-badge v-if="data.item.task_status == '3'" variant="dark">Review</b-badge>
                <b-badge v-if="data.item.task_status == '4'" variant="success">Complete</b-badge>
              </template>
              <template v-slot:cell(view_button)="data">
                <b-btn
                  :to="'/emplyee-user-form/'+data.item.id+'/2'"
                  size="sm"
                  variant="outline-info"
                >
                  <font-awesome-icon icon="eye" />
                </b-btn>
              </template>
            </b-table>
            <b-tabs>
              <b-tab
                title="Activity"
              >Show all activity for this onbaording here - may we should layz load</b-tab>
            </b-tabs>

            <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
          </b-card>
        </template>
      </b-table>
      <p class="text-center mt-3">
        Showing Result From
        <b>{{fromRows}}</b> to
        <b>{{toRows}}</b>
      </p>
      <b-row>
        <b-col cols="2">
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "MyOnboardingComponent",
  data() {
    return {
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Age", sortable: true },
        // { key: "created_by", label: "Created By", sortable: true },
        { key: "type", label: "Workflow", sortable: true },
         { key: "process", label: "Process", sortable: true },
        { key: "employee_name", label: "Employee", sortable: true },
        { key: "progress", label: "Progress", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "", sortable: true },
      ],
      taskTableFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "task_title", label: "Task Title", sortable: true },
        { key: "task_status", label: "Status", sortable: true },
        { key: "view_button", label: "Action", sortable: false },
      ],
      onboardingId: null,
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  methods: {
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "users-data-table");
    },
    async getOnboardingTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        owner_id: localStorage.getItem("userId"),
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        const response = await HTTP(
          "post",
          "api/v1/onboarding/data",
          formData,
          {
            Authorization: token,
          }
        );
        this.isLoading = false;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.totalRows = response.data.total;
        return response.data.data;
      } catch (err) {
        this.isLoading = false;
        return [err];
      }
    },
  },
};
</script>